import { render, staticRenderFns } from "./StepConfirm.vue?vue&type=template&id=0665c76a&scoped=true"
import script from "./StepConfirm.vue?vue&type=script&lang=js"
export * from "./StepConfirm.vue?vue&type=script&lang=js"
import style0 from "./StepConfirm.vue?vue&type=style&index=0&id=0665c76a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0665c76a",
  null
  
)

export default component.exports